<template>
  <div class="card m-2 hover" @click="eventAction()">
    <div
      class="card-img-top"
      :style="`background-image: url(${files + definePicture})`"
    ></div>
    <div class="card-body">
      <h5 class="card-title">{{ defineTitle }}</h5>
      <p class="card-text">
        {{ defineText }}
      </p>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  import router from '../router'

  export default {
    name: 'Event',
    props: {
      info: {
        type: Object,
        default: {
          // id: 0,
          // picture: 'esdeveniment.jpg',
          // date_start: '25/10/2021',
          // date_end: '30/10/2021',
          // title: 'Title',
        },
      },
      eventtype: {
        type: String,
        default: '',
      },
    },
    computed: {
      ...mapState(['files', 'languageSelected']),
      definePicture() {
        return this.eventtype == 'add' ? 'add.png' : this.info.pictures[0]
      },
      defineTitle() {
        let text = ''
        if (this.eventtype == 'add') {
          text = 'Afegir nou esdeveniment'
        } else {
          if (this.info.title && typeof this.info.title == 'object') {
            let result = this.info.title.find(
              (x) => x.key === this.languageSelected
            )
            text = result && result.text ? result.text : this.info.title[0].text
          }
        }
        return text
      },
      defineText() {
        let result = this.info.date_start
        if (this.info.date_end) {
          result += ' - ' + this.info.date_end
        }
        return this.eventtype == 'add' ? '' : result
      },
    },
    methods: {
      eventAction() {
        switch (this.eventtype) {
          case 'add':
            router.push('/event/add')
            break
          case 'current':
          case 'next':
            router.push('/event/edit/' + this.info.id)
            break
          case 'historical':
            router.push('/event/read/' + this.info.id)
            break

          default:
            break
        }
      },
    },
  }
</script>

<style scoped>
  .card-img-top {
    height: 200px;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
  }
  .card {
    vertical-align: top;
    display: inline-block;
    width: 23%;
  }
  .card-title {
    height: 45px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2; /* number of lines to show */
    -webkit-box-orient: vertical;
  }
  .card-text {
    height: 25px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1; /* number of lines to show */
    -webkit-box-orient: vertical;
  }
  .hover {
    cursor: pointer;
  }
  @media screen and (max-width: 1000px) {
    .card {
      width: 30%;
    }
  }
  @media screen and (max-width: 750px) {
    .card {
      width: 45%;
    }
  }
  @media screen and (max-width: 450px) {
    .card {
      width: 90%;
    }
  }
</style>
